<script lang="ts" setup>
	import ErrorNotification from '~/app/common/components/error-notification.vue';
	import { useNotification } from '~/app/common/composables/use-notification';

	const props = defineProps({
		notification: {
			type: Object,
			required: true,
		},
	});

	const { remove } = useNotification();
	function close() {
		remove(props.notification.id);
	}
</script>

<template>
	<ErrorNotification @close="close">
		<p class="text-sm font-medium text-gray-900">We failed to update the application</p>
		<p class="mt-1 text-sm text-gray-500">
			We weren't able to update the application, we are going to retry in 10 seconds. Please wait.
		</p>
	</ErrorNotification>
</template>
